import React, { useState } from "react";
import Collapse from "../../../components/Collapse";

const BET_COLUMNS = [
  { label: "Winner", rangeMin: "100", rangeMax: "3L" },
  { label: "Pair", rangeMin: "100", rangeMax: "25K" },
  { label: "Flush", rangeMin: "100", rangeMax: "10K" },
  { label: "Straight", rangeMin: "100", rangeMax: "10K" },
  { label: "Trio", rangeMin: "100", rangeMax: "5K" },
  { label: "Straight Flush", rangeMin: "100", rangeMax: "5K" },
];

const ROWS = [
  { name: "Tiger", startIndex: 0 },
  { name: "Lion", startIndex: 6 },
  { name: "Dragon", startIndex: 12 },
];

// Reference v-kvalmin / v-kvalmax: 1000 → K, 100000 → L
function kval(n) {
  const v = Number(Number(n || 0).toFixed(2));
  if (v >= 1e3 && v < 1e5) return `${parseFloat((v / 1e3).toFixed(2))}K`;
  if (v >= 1e5) return `${parseFloat((v / 1e5).toFixed(2))}L`;
  return String(parseFloat(v));
}

// Reference toCurrency (en-IN, up to 2 decimals)
function toCurrency(n) {
  return parseFloat(n).toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

/**
 * Teenpatti Test (teen9) bet table — reference markup (allpanel9 admin, isTablet template):
 * .teen1daycasino-container.d-none-small > .teentestother >
 *   .casino-box-row (empty .casino-nation-name.no-border + 6 × header .casino-bl-box with range (i) collapse)
 *   3 × .casino-box-row.mb-4 (Tiger / Lion / Dragon: .casino-nation-name + 6 × .back.casino-bl-box-item)
 * Markets = `sub` (subtype teen9, ordered by sr): Tiger 0-5, Lion 6-11, Dragon 12-17.
 * Styled by the ported reference rules (.teenpattitest … in index.css).
 */
export default function BetTableTeenPatti9({ subData = [], onBetClick, exposures = {} }) {
  // undefined = never toggled (reference: no "collapsed" class until the first click)
  const [openRanges, setOpenRanges] = useState({});

  const toggleRange = (id) => {
    setOpenRanges((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const getExposure = (nat) => {
    if (!nat) return 0;
    return exposures[nat] ?? exposures[nat.toLowerCase()] ?? exposures[nat.trim()] ?? 0;
  };

  return (
    <div className="teen1daycasino-container d-none-small">
      <div className="teentestother">
        <div className="casino-box-row">
          <div className="casino-nation-name no-border" />{" "}
          {BET_COLUMNS.map((col, i) => {
            const rangeId = `range${i + 1}`;
            const state = openRanges[rangeId];
            const market = subData[i];
            return (
              <React.Fragment key={i}>
                {i > 0 && " "}
                <div className="casino-bl-box">
                  <div className="casino-bl-box-item">
                    <b>{col.label}</b>{" "}
                    <div className="float-right">
                      <i
                        data-toggle="collapse"
                        data-target={`#${rangeId}`}
                        className={`fas fa-info-circle${state === false ? " collapsed" : ""}`}
                        aria-expanded={state === undefined ? undefined : String(state)}
                        onClick={() => toggleRange(rangeId)}
                      />{" "}
                      <Collapse id={rangeId} open={!!state} className="icon-range">
                        R:<span>{market?.min != null ? kval(market.min) : col.rangeMin}</span>-
                        <span>{market?.max != null ? kval(market.max) : col.rangeMax}</span>
                      </Collapse>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </div>{" "}
        {ROWS.map((row, r) => (
          <React.Fragment key={row.name}>
            {r > 0 && " "}
            <div className="casino-box-row mb-4">
              <div className="casino-nation-name">
                <b>{row.name}</b>
              </div>{" "}
              {BET_COLUMNS.map((_, colIndex) => {
                const item = subData[row.startIndex + colIndex] || {};
                const odds = item.b;
                const nat = item.nat || "";
                const isLocked = !item.gstatus || item.gstatus !== "OPEN";
                const exposure = Number(getExposure(nat)) || 0;
                return (
                  <div key={colIndex} className="casino-bl-box">
                    <div
                      // padlock at the top only when the cell has a book (no book → centred)
                      className={`back casino-bl-box-item${isLocked ? (exposure ? " suspended lock-top" : " suspended") : ""}`}
                      onClick={() => !isLocked && onBetClick && onBetClick(odds, nat, item)}
                    >
                      <span className="casino-box-odd">{odds}</span>{" "}
                      <span className={`casino-book ${exposure > 0 ? "book-green" : "book-red"}`}>
                        {exposure ? toCurrency(exposure) : 0}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
